import ColumnMap from "csi/table/matrix/ColumnMap";
import { Context } from "csi/def/Context";
import declare from "dojo/_base/declare";
import _ from "lodash";
import Spec from "csi/core/Spec";
import { C8Node } from "csi/typings";

const RatesMatrix = declare(ColumnMap, {
	columnPath: "Parent:MasterCollection/Child:__Parent__/Child:Currency",

	/**
	 * @override
	 * Omit cell for target column
	 */
	_getSpecNodes(ctx: Context, spec: Spec, nodes: C8Node[]): C8Node[] {
		return nodes.filter((node) => node.Target !== spec.columnUrl);
	},
});

export = RatesMatrix;